import { Modal } from '@/components';
import { Button } from '@/components/Button';

export type ConfirmationModalProps = {
    title: string;
    message: string;
    confirmButtonText: string;
    confirmButtonClick: () => void;
    cancelButtonText: string;
    onClose: () => void;
    confirmIsProcessing?: boolean;
};

export function ConfirmationModal({
    title,
    message,
    confirmButtonText,
    cancelButtonText,
    confirmButtonClick,
    onClose,
    confirmIsProcessing = false,
}: ConfirmationModalProps) {
    return (
        <Modal
            className="pt-10"
            containerClassName="max-w-96"
            hideCloseButton={false}
            title={title}
            showCloseButtonInRightCorner={true}
            onClose={() => {
                onClose();
            }}
        >
            <div className="inline-flex flex-col items-start justify-start gap-6">
                <div className="self-stretch text-lg">{message}</div>
                <div className="ml-auto inline-flex items-center justify-end gap-4 pt-4">
                    <Button
                        variant="ghost"
                        className="btn-sm"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {cancelButtonText}
                    </Button>
                    <Button
                        variant="primary"
                        className={`btn-sm ${confirmIsProcessing ? 'button--loading' : ''}`}
                        onClick={() => {
                            confirmButtonClick();
                        }}
                    >
                        {confirmButtonText}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
